module.exports = __webpack_public_path__ + "static/media/cialfo_icon.dab97409.svg";